import { FiltersActionType, FiltersAction } from '../actions/filtersActions';
import { GetFiltersResponse } from '@card/commonlib';

type filtersReducersType = {
  list: {
    data?: GetFiltersResponse;
    fetching: boolean;
    error?: string;
  };
};

const initialState: filtersReducersType = {
  list: {
    data: undefined,
    fetching: false,
    error: undefined
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function filtersReducers(state = initialState, action: FiltersAction): filtersReducersType {
  switch (action.type) {
    case FiltersActionType.Fetch:
      return {
        ...state,
        list: {
          ...state.list,
          fetching: true,
          error: undefined
        }
      };
    case FiltersActionType.FetchSuccess: {
      return {
        ...state,
        list: {
          data: action.payload,
          fetching: false,
          error: undefined
        }
      };
    }
    case FiltersActionType.FetchError:
      return {
        ...state,
        list: {
          ...state.list,
          fetching: false,
          error: action.payload.message
        }
      };
    default:
      return state;
  }
}
export default filtersReducers;
